import { reactive } from 'vue';
import type { ISbStoryData } from '@storyblok/js';
import type { CorePageLayerStoryblok } from '../types/storyblok';

const state = reactive<{
  corePage: ISbStoryData<CorePageLayerStoryblok> | null;
}>({
  corePage: null,
});

export function useLayer() {
  return {
    state,
  };
}
